const sl = {
  // ============================================================
  // COMMON — Skupno za celotno aplikacijo
  // ============================================================
  common: {
    loading: 'Nalaganje...',
    error: 'Napaka',
    save: 'Shrani',
    cancel: 'Prekliči',
    delete: 'Izbriši',
    edit: 'Uredi',
    create: 'Ustvari',
    add: 'Dodaj',
    remove: 'Odstrani',
    close: 'Zapri',
    confirm: 'Potrdi',
    apply: 'Uporabi',
    reset: 'Ponastavi',
    search: 'Iskanje',
    filter: 'Filter',
    clear: 'Počisti',
    back: 'Nazaj',
    next: 'Naprej',
    previous: 'Prejšnji',
    submit: 'Oddaj',
    update: 'Posodobi',
    refresh: 'Osveži',
    export: 'Izvozi',
    import: 'Uvozi',
    download: 'Prenesi',
    upload: 'Naloži',
    print: 'Natisni',
    copy: 'Kopiraj',
    yes: 'Da',
    no: 'Ne',
    ok: 'V redu',
    done: 'Končano',
    select: 'Izberi',
    selectAll: 'Izberi vse',
    deselectAll: 'Prekliči izbor',
    noResults: 'Ni rezultatov',
    noData: 'Ni razpoložljivih podatkov',
    required: 'Obvezno',
    optional: 'Neobvezno',
    actions: 'Dejanja',
    details: 'Podrobnosti',
    overview: 'Pregled',
    summary: 'Povzetek',
    total: 'Skupaj',
    all: 'Vse',
    none: 'Nič',
    name: 'Ime',
    type: 'Vrsta',
    status: 'Stanje',
    date: 'Datum',
    time: 'Čas',
    description: 'Opis',
    notes: 'Opombe',
    comments: 'Komentarji',
    category: 'Kategorija',
    priority: 'Prioriteta',
    nation: 'Država',
    country: 'Država',
    email: 'E-pošta',
    phone: 'Telefon',
    address: 'Naslov',
    location: 'Lokacija',
    coordinates: 'Koordinate',
    latitude: 'Zemljepisna širina',
    longitude: 'Zemljepisna dolžina',
    from: 'Od',
    to: 'Do',
    createdAt: 'Ustvarjeno',
    updatedAt: 'Posodobljeno',
    createdBy: 'Ustvaril',
    modifiedBy: 'Spremenil',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    enabled: 'Omogočeno',
    disabled: 'Onemogočeno',
    showing: 'Prikazano',
    of: 'od',
    page: 'Stran',
    perPage: 'na stran',
    rows: 'vrstice',
    items: 'elementi',
    results: 'rezultati',
    sortBy: 'Razvrsti po',
    ascending: 'Naraščajoče',
    descending: 'Padajoče',
    viewAll: 'Prikaži vse',
    viewDetails: 'Prikaži podrobnosti',
    goBack: 'Pojdi nazaj',
    learnMore: 'Izvedi več',
    seeMore: 'Prikaži več',
    showMore: 'Prikaži več',
    showLess: 'Prikaži manj',
    expandAll: 'Razširi vse',
    collapseAll: 'Strni vse',
    copied: 'Kopirano!',
    saved: 'Shranjeno!',
    deleted: 'Izbrisano!',
    updated: 'Posodobljeno!',
    created: 'Ustvarjeno!',
    success: 'Uspeh',
    warning: 'Opozorilo',
    info: 'Informacija',
    danger: 'Nevarnost',
    unknown: 'Neznano',
    notAvailable: 'Ni na voljo',
    never: 'Nikoli',
    today: 'Danes',
    yesterday: 'Včeraj',
    tomorrow: 'Jutri',
    now: 'Zdaj',
    ago: 'nazaj',
    justNow: 'pravkar',
    minutesAgo: 'pred {{count}} min',
    hoursAgo: 'pred {{count}} ur',
    daysAgo: 'pred {{count}} dni',
    monthsAgo: 'pred {{count}} mes',
    id: 'ID',
    version: 'Različica',
    language: 'Jezik',
    theme: 'Tema',
    darkMode: 'Temni način',
    lightMode: 'Svetli način',
    failedToLoad: 'Nalaganje podatkov ni uspelo',
    failedToSave: 'Shranjevanje ni uspelo',
    failedToDelete: 'Brisanje ni uspelo',
    failedToUpdate: 'Posodobitev ni uspela',
    confirmDelete: 'Ali ste prepričani, da želite to izbrisati?',
    confirmAction: 'Ali ste prepričani?',
    unsavedChanges: 'Imate neshranjene spremembe. Ali ste prepričani, da želite zapustiti stran?',
    pageNotFound: '404 - Stran ni najdena',
    pageNotFoundDesc: 'Stran, ki jo iščete, ne obstaja.',
    backToDashboard: 'Nazaj na nadzorno ploščo',
    characters: 'znaki',
    maxCharacters: 'Največ {{max}} znakov',
    remaining: '{{count}} preostalo',
    selected: '{{count}} izbranih',
    of_total: '{{count}} od {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Glava, stranska vrstica, meniji
  // ============================================================
  nav: {
    dashboard: 'Nadzorna plošča',
    requests: 'Zahteve',
    transports: 'Prevozi',
    myPatients: 'Moji pacienti',
    statistics: 'Statistika',
    flow: 'Tok',
    resources: 'Resources',
    exercise: 'Vaja',
    administration: 'Administracija',
    map: 'Zemljevid',
    info: 'Informacije',
    users: 'Uporabniki',
    assets: 'Sredstva',
    hubs: 'Vozlišča',
    treatmentFacilities: 'Zdravstvene ustanove',
    patientImport: 'Uvoz pacientov',
    assetTemplates: 'Predloge sredstev',
    dayTemplates: 'Dnevne predloge',
    announcementTicker: 'Trak z obvestili',
    exerciseStatistics: 'Statistika vaje',
    settings: 'Nastavitve',
    auditLog: 'Revizijska sled',
    exerciseControl: 'Vodenje vaje',
    dataSync: 'Sinhronizacija podatkov',
    documentation: 'Dokumentacija',
    support: 'Podpora',
    about: 'O sistemu',
    assetContracts: 'Asset Contracts',
    notifications: 'Obvestila',
    schedules: 'Urniki',
    capacityPlanning: 'Načrtovanje zmogljivosti',
    transportPlanning: 'Načrtovanje prevozov',
    transportBooking: 'Rezervacija prevozov',
    flowDiagram: 'Diagram toka',
    changePassword: 'Spremeni geslo',
    missions: 'Misije',
    startPoints: 'Izhodiščne točke',
    hospital: 'Bolnišnica',
  },

  // ============================================================
  // AUTH — Prijava, geslo, seja
  // ============================================================
  auth: {
    login: 'Prijava',
    logout: 'Odjava',
    logoutNow: 'Odjavi se zdaj',
    loggingIn: 'Prijavljanje...',
    loginFailed: 'Prijava ni uspela',
    email: 'E-pošta',
    password: 'Geslo',
    username: 'Uporabniško ime',
    enterEmail: 'Vnesite svoj e-poštni naslov',
    enterPassword: 'Vnesite svoje geslo',
    enterUsername: 'Vnesite svoje uporabniško ime',
    forgotPassword: 'Pozabljeno geslo?',
    forgotPasswordTitle: 'Pozabljeno geslo',
    forgotPasswordDesc: 'Vnesite svoje uporabniško ime in e-poštni naslov. Če se oba podatka ujemata, bodo administratorji obveščeni za ponastavitev vašega gesla.',
    requestPasswordReset: 'Zahtevaj ponastavitev gesla',
    sending: 'Pošiljanje...',
    backToLogin: 'Nazaj na prijavo',
    pleaseWait: 'Prosimo počakajte pred ponovnim poskusom.',
    requestFailed: 'Zahteva ni uspela',
    credentialsMatch: 'Če se poverilnice ujemajo, so bili administratorji obveščeni.',
    forAccess: 'Za dostop se obrnite na svojega skrbnika sistema.',
    changePassword: 'Spremeni geslo',
    currentPassword: 'Trenutno geslo',
    newPassword: 'Novo geslo',
    confirmPassword: 'Potrdi geslo',
    passwordChanged: 'Geslo je bilo uspešno spremenjeno',
    passwordMismatch: 'Gesli se ne ujemata',
    passwordTooShort: 'Geslo mora imeti vsaj 8 znakov',
    changingPassword: 'Spreminjanje...',
    mustChangePassword: 'Pred nadaljevanjem morate spremeniti geslo.',
    sessionExpiring: 'Seja poteka',
    sessionExpireText: 'Vaša seja bo potekla čez <strong>{{time}}</strong>. Prosimo shranite svoje delo in se ponovno prijavite.',
    dismiss: 'Opusti',
    switchNation: 'Zamenjaj državo',
    returnTo: 'Vrni se k {{nation}}',
    viewingAs: 'Gledate kot',
    loggedInAs: 'prijavljen kot {{nation}}',
    trainingMode: 'SAMO ZA NAMENE USPOSABLJANJA',
    dedication: 'Ustvarjeno z ljubeznijo in predanostjo poklicu',
  },

  // ============================================================
  // ROLES — Uporabniške vloge in oznake
  // ============================================================
  roles: {
    admin: 'Skrbnik sistema',
    excon: 'Vodja vaje',
    eu: 'Koordinator EU',
    planner: 'Načrtovalec',
    hub: 'Upravljavec vozlišča',
    nation: 'Država',
    readOnly: 'Samo za branje',
    systemAdmin: 'Skrbnik sistema',
    transportPlanner: 'Načrtovalec prevozov',
    systemRoles: 'Sistemske vloge',
  },

  // ============================================================
  // STATUS — Stanja zahtev, ponudb, misij
  // ============================================================
  status: {
    draft: 'Osnutek',
    underReview: 'V pregledu',
    published: 'Objavljeno',
    underSelection: 'V izbiri',
    accepted: 'Sprejeto',
    planned: 'Načrtovano',
    inTransit: 'V prevozu',
    completed: 'Zaključeno',
    closed: 'Zaprto',
    withdrawn: 'Umaknjeno',
    pending: 'V čakanju',
    rejected: 'Zavrnjeno',
    cancelled: 'Preklicano',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    review: 'Pregled',
    selection: 'Izbira',
    transit: 'Prevoz',
  },

  // ============================================================
  // CATEGORIES — Kategorije zahtev
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Osebje',
    material: 'Material',
    equipment: 'Oprema',
    other: 'Drugo',
    news: 'Novice',
  },

  // ============================================================
  // URGENCY — Stopnje nujnosti
  // ============================================================
  urgency: {
    routine: 'Redna',
    priority: 'Prednostna',
    urgent: 'Nujna',
    immediate: 'Takojšnja',
  },

  // ============================================================
  // ASSETS — Vrste prevoznih sredstev
  // ============================================================
  assetTypes: {
    train: 'Vlak',
    ship: 'Ladja',
    aircraft: 'Letalo',
    bus: 'Avtobus',
    ambulance: 'Reševalno vozilo',
    drone: 'Dron',
    helicopter: 'Helikopter',
    ferry: 'Trajekt',
    other: 'Drugo',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Nadzorna plošča',
    goodMorning: 'Dobro jutro',
    goodAfternoon: 'Dober dan',
    goodEvening: 'Dober večer',
    lastLogin: 'Zadnja prijava',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Prevozna sredstva',
    treatmentFacilities: 'Zdravstvene ustanove',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistika zahtev',
    viewAllRequests: 'Prikaži vse zahteve',
    availableAssets: 'Razpoložljiva sredstva',
    seated: 'Sedeči',
    lying: 'Ležeči',
    intensive: 'Intenzivni',
    notifications: 'Obvestila',
    markAllRead: 'Označi vse kot prebrano',
    noNotifications: 'Še ni obvestil',
    notifiedWhenActivity: 'Obveščeni boste, ko bo prišlo do nove dejavnosti',
    viewDetailsBtn: 'Prikaži podrobnosti',
    nationUsers: 'Uporabniki države',
    user: 'Uporabnik',
    roles: 'Vloge',
    noUsersFound: 'Ni najdenih uporabnikov',
    participatingNations: 'Sodelujoče države',
    exerciseDisclaimer: 'Ta sistem je namenjen samo za uporabo pri vajah. Vnašajte izključno simulirane podatke vaje. Delovni tokovi so prilagojeni scenariju vaje in se lahko razlikujejo od realnih postopkov. Pravila IT varnosti in varstva podatkov ostajajo v celoti veljavna.',
    notConfigured: 'Ni konfigurirano',
    requestCount: '{{count}} zahtev(a)',
    clickToView: 'Kliknite za ogled',
    systemAdministration: 'Administracija sistema',
    exerciseControlTitle: 'Vodenje vaje',
    euCoordination: 'Koordinacija EU',
    transportPlanningTitle: 'Načrtovanje prevozov',
    hubManagement: 'Upravljanje vozlišč',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nova zahteva',
    myDrafts: 'Moji osnutki',
    pendingReview: 'Čaka na pregled',
    activeTransports: 'Aktivni prevozi',
    myPatients: 'Moji pacienti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Zahteve',
    newRequest: 'Nova zahteva',
    createRequest: 'Ustvari zahtevo',
    editRequest: 'Uredi zahtevo',
    requestDetail: 'Podrobnosti zahteve',
    requestId: 'ID zahteve',
    fromNation: 'Od države',
    toNation: 'Za državo',
    requestingNation: 'Država prosilka',
    receivingNation: 'Država prejemnica',
    category: 'Kategorija',
    urgency: 'Nujnost',
    status: 'Stanje',
    patients: 'Pacienti',
    patientCount: 'Število pacientov',
    offers: 'Ponudbe',
    offerCount: 'Število ponudb',
    created: 'Ustvarjeno',
    updated: 'Posodobljeno',
    submittedBy: 'Oddal',
    reviewedBy: 'Pregledal',
    description: 'Opis',
    medicalDetails: 'Zdravstveni podatki',
    transportDetails: 'Podatki o prevozu',
    additionalInfo: 'Dodatne informacije',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Točka odhoda',
    arrivalPoint: 'Točka prihoda',
    estimatedDeparture: 'Predviden odhod',
    estimatedArrival: 'Predviden prihod',
    submitForReview: 'Oddaj v pregled',
    publish: 'Objavi',
    startSelection: 'Začni izbiro',
    acceptOffer: 'Sprejmi ponudbo',
    markInTransit: 'Označi kot v prevozu',
    markCompleted: 'Označi kot zaključeno',
    closeRequest: 'Zapri zahtevo',
    withdrawRequest: 'Umakni zahtevo',
    withdraw: 'Umakni',
    revertToDraft: 'Vrni v osnutek',
    deleteRequest: 'Izbriši zahtevo',
    duplicateRequest: 'Podvoji zahtevo',
    createFollowUp: 'Ustvari konsolidirano zahtevo',
    followUpRequest: 'Konsolidirana zahteva',
    parentRequest: 'Izvorna zahteva',
    childRequests: 'Konsolidirane zahteve',
    noRequests: 'Ni najdenih zahtev',
    noOffers: 'Še ni ponudb',
    addPatient: 'Dodaj pacienta',
    removePatient: 'Odstrani pacienta',
    patientDetails: 'Podatki o pacientu',
    contactPerson: 'Kontaktna oseba',
    contactPhone: 'Kontaktni telefon',
    contactEmail: 'Kontaktna e-pošta',
    specialRequirements: 'Posebne zahteve',
    medicalEquipment: 'Medicinska oprema',
    accompaniment: 'Spremstvo',
    timeline: 'Časovnica',
    history: 'Zgodovina',
    addComment: 'Dodaj komentar',
    writeComment: 'Napišite komentar...',
    postComment: 'Objavi komentar',
    posting: 'Objavljanje...',
    noComments: 'Še ni komentarjev',
    coverageBar: 'Pokritost',
    covered: 'pokrito',
    uncovered: 'nepokrito',
    filterByStatus: 'Filtriraj po stanju',
    filterByCategory: 'Filtriraj po kategoriji',
    filterByNation: 'Filtriraj po državi',
    searchRequests: 'Iskanje zahtev...',
    confirmWithdraw: 'Ali ste prepričani, da želite umakniti to zahtevo?',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to zahtevo?',
    confirmPublish: 'Ali ste prepričani, da želite objaviti to zahtevo? Vidna bo vsem državam.',
    confirmStartSelection: 'Ali ste prepričani, da želite začeti izbiro? Države bodo lahko oddajale ponudbe.',
    warningStartSelection: 'Začetek izbire bo to zahtevo prikazal vsem sodelujočim državam. Lahko bodo oddajale ponudbe za paciente v tej zahtevi. Tega dejanja ni mogoče razveljaviti.',
    warningMakeOffer: 'Z oddajo te ponudbe se vaša država zavezuje k zagotovitvi predlagane pomoči. To dejanje bo obvestilo državo prosilko in vodenje vaje.',
    saveDraft: 'Shrani osnutek',
    saving: 'Shranjevanje...',
    saveAndSubmit: 'Shrani in oddaj',
    step: 'Korak {{number}}',
    generalInfo: 'Splošne informacije',
    patientInfo: 'Podatki o pacientu',
    logisticsInfo: 'Logistične informacije',
    reviewSubmit: 'Pregled in oddaja',
    requestTitle: 'Naslov zahteve',
    requestDescription: 'Opis zahteve',
    numberOfPatients: 'Število pacientov',
    typeOfAssistance: 'Vrsta pomoči',
    medicalTreatment: 'Zdravstvena oskrba',
    transportAssistance: 'Prevozna pomoč',
    both: 'Oboje',
    treatmentOnly: 'Samo zdravljenje',
    transportOnly: 'Samo prevoz',
    validationErrors: 'Prosimo odpravite naslednje napake:',
    fieldRequired: 'To polje je obvezno',
    selectExitHub: 'Izberite izhodno vozlišče',
    createExitHub: 'Ustvari izhodno vozlišče',
    backToRequests: 'Nazaj na zahteve',
    noRequestsFound: 'Ni najdenih zahtev',
    createFirstRequest: 'Ustvarite svojo prvo zahtevo za začetek',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ponudbe',
    createOffer: 'Ustvari ponudbo',
    makeOffer: 'Oddaj ponudbo',
    manageOffers: 'Upravljaj ponudbe',
    offerDetail: 'Podrobnosti ponudbe',
    offerId: 'ID ponudbe',
    offeringNation: 'Država ponudnica',
    offerType: 'Vrsta ponudbe',
    treatment: 'Zdravljenje',
    transport: 'Prevoz',
    combined: 'Kombinirano',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ponudba zdravljenja',
    transportOffer: 'Ponudba prevoza',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Izberi paciente',
    selectedPatients: 'Izbrani pacienti',
    patientSelection: 'Izbira pacientov',
    offerConfiguration: 'Konfiguracija ponudbe',
    reviewOffer: 'Preglej ponudbo',
    submitOffer: 'Oddaj ponudbo',
    submitting: 'Oddajanje...',
    acceptOffer: 'Sprejmi ponudbo',
    rejectOffer: 'Zavrni ponudbo',
    withdrawOffer: 'Umakni ponudbo',
    noOffers: 'Ni razpoložljivih ponudb',
    noOffer: 'No Offer',
    offerStatus: 'Stanje ponudbe',
    offerDate: 'Datum ponudbe',
    transportAsset: 'Prevozno sredstvo',
    departureDate: 'Datum odhoda',
    arrivalDate: 'Datum prihoda',
    treatmentFacility: 'Zdravstvena ustanova',
    capacity: 'Zmogljivost',
    availableCapacity: 'Razpoložljiva zmogljivost',
    totalCapacity: 'Skupna zmogljivost',
    selectAsset: 'Izberi sredstvo',
    selectFacility: 'Izberi ustanovo',
    offerNotes: 'Opombe k ponudbi',
    confirmAccept: 'Ali ste prepričani, da želite sprejeti to ponudbo?',
    confirmReject: 'Ali ste prepričani, da želite zavrniti to ponudbo?',
    extendTransport: 'Podaljšaj prevoz',
    transportExtension: 'Podaljšanje prevoza',
    comparisonView: 'Primerjalni pogled',
    shortlist: 'Ožji izbor',
    addToShortlist: 'Dodaj v ožji izbor',
    removeFromShortlist: 'Odstrani iz ožjega izbora',
    leaveConfirmTitle: 'Zapustiti to stran?',
    leaveConfirmMessage: 'Imate neshranjene spremembe. Ali ste prepričani, da želite zapustiti stran?',
    stayOnPage: 'Ostani na strani',
    leavePage: 'Zapusti stran',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Prevozi',
    missionDetail: 'Podrobnosti prevoza',
    missionId: 'ID prevoza',
    missionStatus: 'Stanje prevoza',
    createMission: 'Ustvari prevoz',
    overview: 'Pregled',
    patientsTab: 'Pacienti',
    transportsTab: 'Odseki prevoza',
    treatmentTab: 'Zdravljenje',
    reviewTab: 'Pregled',
    departure: 'Odhod',
    arrival: 'Prihod',
    origin: 'Izhodišče',
    destination: 'Cilj',
    stops: 'Postanki',
    addStop: 'Dodaj postanek',
    removeStop: 'Odstrani postanek',
    stopName: 'Ime postanka',
    stopType: 'Vrsta postanka',
    estimatedTime: 'Predviden čas',
    actualTime: 'Dejanski čas',
    asset: 'Sredstvo',
    driver: 'Voznik',
    crew: 'Posadka',
    noMissions: 'Ni najdenih prevozov',
    completeMission: 'Zaključi prevoz',
    cancelMission: 'Prekliči prevoz',
    startTransport: 'Začni prevoz',
    missionChain: 'Veriga prevozov',
    linkedMissions: 'Povezani prevozi',
    handover: 'Predaja',
    handoverPoint: 'Točka predaje',
    pickupPoint: 'Točka prevzema',
    dropoffPoint: 'Točka oddaje',
    searchTransports: 'Iskanje prevozov...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacienti',
    myPatients: 'Moji pacienti',
    patientId: 'ID pacienta',
    firstName: 'Ime',
    lastName: 'Priimek',
    dateOfBirth: 'Datum rojstva',
    age: 'Starost',
    gender: 'Spol',
    male: 'Moški',
    female: 'Ženska',
    other: 'Drugo',
    nationality: 'Državljanstvo',
    diagnosis: 'Diagnoza',
    condition: 'Stanje',
    stable: 'Stabilno',
    critical: 'Kritično',
    serious: 'Resno',
    treatmentNeeded: 'Potrebno zdravljenje',
    allergies: 'Alergije',
    medications: 'Zdravila',
    bloodType: 'Krvna skupina',
    weight: 'Teža (kg)',
    infectious: 'Nalezljiv',
    mentalHealth: 'Duševno zdravje',
    mobility: 'Mobilnost',
    ambulatory: 'Pokreten',
    wheelchair: 'Invalidski voziček',
    stretcher: 'Nosila',
    intensive: 'Intenzivna nega',
    oxygenRequired: 'Potreben kisik',
    ventilator: 'Ventilator',
    medicalEscort: 'Zdravstveno spremstvo',
    noPatients: 'Ni najdenih pacientov',
    patientDetails: 'Podatki o pacientu',
    medicalHistory: 'Zdravstvena anamneza',
    travelDocuments: 'Potovalni dokumenti',
    passport: 'Potni list',
    pseudonymizedId: 'Psevdonimizirani ID',
    sensitiveData: 'Občutljivi podatki',
    journey: 'Pot pacienta',
    assignedTo: 'Dodeljen',
    currentLocation: 'Trenutna lokacija',
    importPatients: 'Uvozi paciente',
    exportPatients: 'Izvozi paciente',
    seated: 'Sedeči',
    lying: 'Ležeči',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Uporabniki',
    createUser: 'Ustvari uporabnika',
    editUser: 'Uredi uporabnika',
    deleteUser: 'Izbriši uporabnika',
    username: 'Uporabniško ime',
    displayName: 'Prikazno ime',
    email: 'E-pošta',
    password: 'Geslo',
    role: 'Vloga',
    roles: 'Vloge',
    nation: 'Država',
    active: 'Aktivno',
    lastLogin: 'Zadnja prijava',
    createdAt: 'Ustvarjeno',
    isNation: 'Država',
    isEU: 'EU',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Načrtovalec',
    isHub: 'Vozlišče',
    isReadOnly: 'Samo za branje',
    noUsers: 'Ni najdenih uporabnikov',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati tega uporabnika?',
    resetPassword: 'Ponastavi geslo',
    generatePassword: 'Generiraj geslo',
    searchUsers: 'Iskanje uporabnikov...',
    userCreated: 'Uporabnik uspešno ustvarjen',
    userUpdated: 'Uporabnik uspešno posodobljen',
    userDeleted: 'Uporabnik uspešno izbrisan',
    selectNation: 'Izberite državo',
    mustChangePassword: 'Mora spremeniti geslo ob naslednji prijavi',
    flagImage: 'Slika zastave',
    exportUsers: 'Izvozi uporabnike',
    importUsers: 'Uvozi uporabnike',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Sredstva',
    createAsset: 'Ustvari sredstvo',
    editAsset: 'Uredi sredstvo',
    deleteAsset: 'Izbriši sredstvo',
    assetName: 'Ime sredstva',
    assetType: 'Vrsta sredstva',
    capacitySeated: 'Zmogljivost (sedeči)',
    capacityLying: 'Zmogljivost (ležeči)',
    capacityIntensive: 'Zmogljivost (intenzivna)',
    owner: 'Lastnik',
    operator: 'Upravljavec',
    baseLocation: 'Osnovna lokacija',
    range: 'Doseg',
    speed: 'Hitrost',
    noAssets: 'Ni najdenih sredstev',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to sredstvo?',
    searchAssets: 'Iskanje sredstev...',
    assetCreated: 'Sredstvo uspešno ustvarjeno',
    assetUpdated: 'Sredstvo uspešno posodobljeno',
    assetDeleted: 'Sredstvo uspešno izbrisano',
    exportAssets: 'Izvozi sredstva',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Vozlišča',
    startPoints: 'Izhodiščne točke',
    createHub: 'Ustvari vozlišče',
    editHub: 'Uredi vozlišče',
    deleteHub: 'Izbriši vozlišče',
    hubName: 'Ime vozlišča',
    hubType: 'Vrsta vozlišča',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Vhodno vozlišče',
    airport: 'Letališče',
    seaport: 'Pristanišče',
    railStation: 'Železniška postaja',
    roadPoint: 'Cestna točka',
    ucpmClassification: 'Klasifikacija UCPM',
    icaoCode: 'Koda ICAO',
    iataCode: 'Koda IATA',
    noHubs: 'Ni najdenih vozlišč',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to vozlišče?',
    searchHubs: 'Iskanje vozlišč...',
    nationAssignment: 'Dodelitev držav',
    assignNations: 'Dodeli države',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Zdravstvene ustanove',
    createFacility: 'Ustvari ustanovo',
    editFacility: 'Uredi ustanovo',
    deleteFacility: 'Izbriši ustanovo',
    facilityName: 'Ime ustanove',
    facilityType: 'Vrsta ustanove',
    hospitalName: 'Ime bolnišnice',
    bedCapacity: 'Zmogljivost postelj',
    specialties: 'Specialnosti',
    availableBeds: 'Razpoložljive postelje',
    totalBeds: 'Skupno število postelj',
    contactPerson: 'Kontaktna oseba',
    noFacilities: 'Ni najdenih zdravstvenih ustanov',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to ustanovo?',
    searchFacilities: 'Iskanje ustanov...',
    hubNationAssignment: 'Dodelitev držav vozlišču',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Urniki',
    createSchedule: 'Ustvari urnik',
    editSchedule: 'Uredi urnik',
    deleteSchedule: 'Izbriši urnik',
    scheduleName: 'Ime urnika',
    scheduleType: 'Vrsta urnika',
    recurring: 'Ponavljajoč',
    oneTime: 'Enkraten',
    frequency: 'Pogostost',
    daily: 'Dnevno',
    weekly: 'Tedensko',
    startDate: 'Datum začetka',
    endDate: 'Datum konca',
    departureTime: 'Čas odhoda',
    arrivalTime: 'Čas prihoda',
    stops: 'Postanki',
    addStop: 'Dodaj postanek',
    noSchedules: 'Ni najdenih urnikov',
    bookings: 'Rezervacije',
    timeline: 'Časovnica',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Obvestila',
    markAllRead: 'Označi vse kot prebrano',
    markAsRead: 'Označi kot prebrano',
    markAsUnread: 'Označi kot neprebrano',
    noNotifications: 'Ni obvestil',
    viewAll: 'Prikaži vsa obvestila',
    settings: 'Nastavitve obvestil',
    emailNotifications: 'E-poštna obvestila',
    inAppNotifications: 'Obvestila v aplikaciji',
    notifyOn: 'Obvesti me o',
    requestCreated: 'Nova zahteva',
    requestPublished: 'Zahteva objavljena',
    requestClosed: 'Zahteva zaprta',
    requestCompleted: 'Zahteva zaključena',
    commentAdded: 'Nov komentar',
    offerReceived: 'Ponudba prejeta',
    offerAccepted: 'Ponudba sprejeta',
    statusChanged: 'Stanje spremenjeno',
    selectionStarted: 'Izbira začeta',
    missionCreated: 'Prevoz ustvarjen',
    missionStatusUpdated: 'Prevoz posodobljen',
    transportPartnerNamed: 'Prevozni partner',
    transportExtensionReceived: 'Podaljšanje prevoza',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Nastavitve',
    general: 'Splošno',
    system: 'Sistem',
    email: 'E-pošta',
    sync: 'Sinhronizacija',
    security: 'Varnost',
    appearance: 'Videz',
    systemName: 'Ime sistema',
    systemEmail: 'Sistemska e-pošta',
    maintenanceMode: 'Način vzdrževanja',
    readOnlyMode: 'Način samo za branje',
    emailEnabled: 'E-pošta omogočena',
    smtpHost: 'SMTP gostitelj',
    smtpPort: 'SMTP vrata',
    smtpUser: 'SMTP uporabnik',
    smtpPassword: 'SMTP geslo',
    senderEmail: 'E-pošta pošiljatelja',
    senderName: 'Ime pošiljatelja',
    testEmail: 'Pošlji testno e-pošto',
    syncEnabled: 'Sinhronizacija omogočena',
    syncUrl: 'URL sinhronizacije',
    syncApiKey: 'API ključ sinhronizacije',
    settingsSaved: 'Nastavitve uspešno shranjene',
    helpdesk: 'Služba za pomoč',
    helpdeskTitle: 'Naslov službe za pomoč',
    helpdeskEmail: 'E-pošta službe za pomoč',
    helpdeskPhone: 'Telefon službe za pomoč',
    helpdeskInfo: 'Informacije o službi za pomoč',
    realLifeSupport: 'Podpora v resničnem življenju',
    trainingMode: 'Način usposabljanja',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Revizijska sled',
    action: 'Dejanje',
    user: 'Uporabnik',
    target: 'Cilj',
    details: 'Podrobnosti',
    timestamp: 'Časovni žig',
    ipAddress: 'IP naslov',
    noLogs: 'Ni najdenih revizijskih zapisov',
    searchLogs: 'Iskanje zapisov...',
    filterByAction: 'Filtriraj po dejanju',
    filterByUser: 'Filtriraj po uporabniku',
    exportLogs: 'Izvozi zapise',
    exportCsv: 'Izvozi CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Vodenje vaje',
    currentDay: 'Trenutni dan',
    exerciseDay: 'Dan vaje',
    nextDay: 'Naslednji dan',
    previousDay: 'Prejšnji dan',
    resetExercise: 'Ponastavi vajo',
    startExercise: 'Začni vajo',
    endExercise: 'Končaj vajo',
    dayReset: 'Ponastavitev dneva',
    confirmReset: 'Ali ste prepričani, da želite ponastaviti dan vaje? S tem boste izbrisali vse podatke za trenutni dan.',
    resetInProgress: 'Ponastavitev poteka...',
    maintenanceMode: 'Način vzdrževanja',
    enableMaintenance: 'Omogoči vzdrževanje',
    disableMaintenance: 'Onemogoči vzdrževanje',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sinhronizacija podatkov',
    syncStatus: 'Stanje sinhronizacije',
    lastSync: 'Zadnja sinhronizacija',
    pendingItems: 'Čakajoči elementi',
    syncNow: 'Sinhroniziraj zdaj',
    syncing: 'Sinhronizacija...',
    syncSuccess: 'Sinhronizacija uspešno zaključena',
    syncFailed: 'Sinhronizacija ni uspela',
    outbox: 'Izhodni predal',
    inbox: 'Vhodni predal',
    configuration: 'Konfiguracija',
    targetUrl: 'Ciljni URL',
    apiKey: 'API ključ',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Zemljevid',
    layers: 'Plasti',
    requests: 'Zahteve',
    hubs: 'Vozlišča',
    facilities: 'Ustanove',
    routes: 'Poti',
    showAll: 'Prikaži vse',
    hideAll: 'Skrij vse',
    zoomIn: 'Približaj',
    zoomOut: 'Oddalji',
    resetView: 'Ponastavi pogled',
    satellite: 'Satelitski',
    terrain: 'Teren',
    offline: 'Brez povezave',
    online: 'S povezavo',
    tilesOffline: 'Ploščice zemljevida se strežejo lokalno',
    tilesOnline: 'Ploščice zemljevida se nalagajo iz spletnih strežnikov',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Pregled',
    requestsByStatus: 'Zahteve po stanju',
    requestsByCategory: 'Zahteve po kategoriji',
    requestsByNation: 'Zahteve po državi',
    offersByStatus: 'Ponudbe po stanju',
    patientsByCondition: 'Pacienti po stanju',
    transportsByStatus: 'Prevozi po stanju',
    timeline: 'Časovnica',
    totalRequests: 'Skupno število zahtev',
    totalOffers: 'Skupno število ponudb',
    totalPatients: 'Skupno število pacientov',
    totalTransports: 'Skupno število prevozov',
    averageResponseTime: 'Povprečni odzivni čas',
    completionRate: 'Stopnja zaključenosti',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistika vaje',
    overview: 'Pregled',
    byCategory: 'Po kategoriji',
    byNation: 'Po državi',
    byDay: 'Po dnevu',
    totalPatientsMoved: 'Skupno število prepeljanih pacientov',
    totalRequestsProcessed: 'Skupno število obdelanih zahtev',
    averageProcessingTime: 'Povprečni čas obdelave',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagram toka',
    sankey: 'Sankey',
    nodeGraph: 'Vozliščni graf',
    refresh: 'Osveži',
    noData: 'Ni razpoložljivih podatkov o toku',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O sistemu',
    version: 'Različica',
    systemInfo: 'Informacije o sistemu',
    buildDate: 'Datum izgradnje',
    environment: 'Okolje',
    description: 'ARCOS — Napredni sistem za komunikacijo zahtev',
    subtitle: 'Pomoč žrtvam in medicinske operacije',
    whatIsArcos: 'Kaj je ARCOS? – Pojasnilo za udeležence vaje',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'S podporo MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – kjer radovednost sreča sodelovanje.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacija',
    gettingStarted: 'Začetek',
    userGuide: 'Uporabniški priročnik',
    faq: 'Pogosta vprašanja',
    troubleshooting: 'Odpravljanje težav',
    apiReference: 'API referenca',
    downloadTemplate: 'Prenesi predlogo',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Uvoz pacientov',
    uploadFile: 'Naloži datoteko',
    selectFile: 'Izberi datoteko',
    preview: 'Predogled',
    importNow: 'Uvozi zdaj',
    importing: 'Uvažanje...',
    importSuccess: '{{count}} pacientov uspešno uvoženih',
    importFailed: 'Uvoz ni uspel',
    downloadTemplate: 'Prenesi predlogo',
    dragDrop: 'Povlecite in spustite datoteko sem ali kliknite za izbiro',
    supportedFormats: 'Podprte oblike: XLSX, XLS, CSV',
    rowsFound: '{{count}} najdenih vrstic',
    validRows: '{{count}} veljavnih vrstic',
    invalidRows: '{{count}} neveljavnih vrstic',
    duplicateRows: '{{count}} podvojenih vrstic',
    previewData: 'Predogled podatkov',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Načrtovanje prevozov',
    planRoute: 'Načrtuj pot',
    routeBuilder: 'Graditelj poti',
    addWaypoint: 'Dodaj vmesno točko',
    removeWaypoint: 'Odstrani vmesno točko',
    estimatedDuration: 'Predvideno trajanje',
    distance: 'Razdalja',
    selectVehicle: 'Izberi vozilo',
  },

  transportBooking: {
    title: 'Rezervacija prevozov',
    bookTransport: 'Rezerviraj prevoz',
    availableSlots: 'Razpoložljivi termini',
    bookingConfirmed: 'Rezervacija potrjena',
    cancelBooking: 'Prekliči rezervacijo',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Načrtovanje zmogljivosti',
    totalCapacity: 'Skupna zmogljivost',
    usedCapacity: 'Uporabljena zmogljivost',
    availableCapacity: 'Razpoložljiva zmogljivost',
    utilizationRate: 'Stopnja izkoriščenosti',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Predloge sredstev',
    dayTemplates: 'Dnevne predloge',
    createTemplate: 'Ustvari predlogo',
    editTemplate: 'Uredi predlogo',
    deleteTemplate: 'Izbriši predlogo',
    templateName: 'Ime predloge',
    applyTemplate: 'Uporabi predlogo',
    noTemplates: 'Ni najdenih predlog',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to predlogo?',
    confirmApply: 'Ali ste prepričani, da želite uporabiti to predlogo? S tem boste prepisali obstoječe podatke.',
    exportTemplates: 'Izvozi predloge',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Trak z obvestili',
    createAnnouncement: 'Ustvari obvestilo',
    editAnnouncement: 'Uredi obvestilo',
    deleteAnnouncement: 'Izbriši obvestilo',
    message: 'Sporočilo',
    startTime: 'Čas začetka',
    endTime: 'Čas konca',
    active: 'Aktivno',
    noAnnouncements: 'Ni obvestil',
    confirmDelete: 'Ali ste prepričani, da želite izbrisati to obvestilo?',
  },

  // ============================================================
  // COMPONENTS — Nizi ponovljivih komponent
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Iskanje...',
      noResults: 'Ni rezultatov',
      showing: 'Prikazano {{from}} do {{to}} od {{total}}',
      rowsPerPage: 'Vrstic na stran',
      previousPage: 'Prejšnja stran',
      nextPage: 'Naslednja stran',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potrdi',
      cancel: 'Prekliči',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Neshranjene spremembe',
      message: 'Imate neshranjene spremembe. Ali ste prepričani, da želite zapustiti to stran?',
      stay: 'Ostani na strani',
      leave: 'Zapusti stran',
    },
    // EmptyState
    emptyState: {
      noData: 'Ni razpoložljivih podatkov',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Nekaj je šlo narobe',
      message: 'Prišlo je do nepričakovane napake. Prosimo poskusite osvežiti stran.',
      retry: 'Poskusi znova',
    },
    // ExportButton
    exportButton: {
      export: 'Izvozi',
      exporting: 'Izvažanje...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Natisni',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Osnutek',
      review: 'Pregled',
      published: 'Objavljeno',
      selection: 'Izbira',
      inTransit: 'V prevozu',
      completed: 'Zaključeno',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Spletna instanca',
      message: 'Način samo za branje. Podatki se sinhronizirajo s primarnega strežnika.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Gledate kot',
      loggedInAs: 'prijavljen kot {{nation}}',
      returnTo: 'Vrni se k {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Iskanje strani, zahtev, prevozov...',
      searching: 'Iskanje...',
      noResults: 'Ni rezultatov za "{{query}}"',
      navigate: 'Navigiraj',
      select: 'Izberi',
      close: 'Zapri',
      pages: {
        dashboard: 'Nadzorna plošča',
        requests: 'Zahteve',
        transports: 'Prevozi',
        map: 'Zemljevid',
        myPatients: 'Moji pacienti',
        flowDiagram: 'Diagram toka',
        statistics: 'Statistika',
        assets: 'Sredstva',
        startPoints: 'Izhodiščne točke / Vozlišča',
        treatmentFacilities: 'Zdravstvene ustanove',
        users: 'Uporabniki',
        settings: 'Nastavitve',
        auditLogs: 'Revizijska sled',
        exerciseControl: 'Vodenje vaje',
        dataSync: 'Sinhronizacija podatkov',
        patientImport: 'Uvoz pacientov',
        notifications: 'Obvestila',
        documentation: 'Dokumentacija',
      },
      actions: {
        importPatientsJson: 'Uvozi Pacientov (JSON)',
        importPatientsExcel: 'Uvozi Pacientov (Excel)',
        importUsers: 'Uvozi Uporabnikov (Excel)',
        importAssetTemplates: 'Uvozi Predloge sredstev (Excel)',
        importDayTemplates: 'Uvozi Vnose dnevne predloge (Excel)',
        exportRequests: 'Izvozi Zahtevkov (Excel)',
        exportPatients: 'Izvozi Pacientov (Excel)',
        exportUsers: 'Izvozi Uporabnikov (Excel)',
        exportCredentials: 'Izvozi Poverilnice (PDF)',
        exportAuditExcel: 'Izvozi Revizijski dnevnik (Excel)',
        exportAuditPdf: 'Izvozi Revizijski dnevnik (PDF)',
        pagePatientImport: 'Stran uvoza pacientov',
        pageRequestDetail: 'Stran podrobnosti zahtevka',
        pageUsers: 'Stran upravljanja uporabnikov',
        pageAssetTemplates: 'Stran predlog sredstev',
        pageDayTemplates: 'Stran dnevnih predlog',
        pageRequests: 'Stran seznama zahtevkov',
        pageAuditLogs: 'Stran revizijskega dnevnika',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Seja poteka',
      message: 'Vaša seja bo potekla čez <strong>{{time}}</strong>. Prosimo shranite svoje delo in se ponovno prijavite.',
      dismiss: 'Opusti',
      logoutNow: 'Odjavi se zdaj',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Izberite 4 časovne pasove',
      configure: 'Konfiguriraj časovne pasove',
      reset: 'Ponastavi',
      apply: 'Uporabi',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Izberi lokacijo',
      latitude: 'Zemljepisna širina',
      longitude: 'Zemljepisna dolžina',
      clickToSelect: 'Kliknite na zemljevid za izbiro lokacije',
    },
    // Modal
    modal: {
      close: 'Zapri',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Domov',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Vzdrževanje sistema',
    message: 'Sistem se ponastavlja za naslednji dan vaje. Prosimo počakajte, da se postopek zaključi.',
    autoRefresh: 'Ta stran se bo samodejno osvežila, ko bo sistem ponovno na voljo.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Vsaj 10 znakov',
    uppercase: '1 velika črka',
    lowercase: '1 mala črka',
    digit: '1 številka',
    special: '1 poseben znak',
  },
};

export default sl;
